import { API_BASE } from '../config/api';

async function safeJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : null;
  } catch {
    return null;
  }
}

export async function fetchProducts(params = {}) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    usp.set(k, String(v));
  });
  const qs = usp.toString();
  const res = await fetch(`${API_BASE}/products${qs ? `?${qs}` : ''}`);
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to load products');
  return await safeJson(res);
}

export async function fetchProduct(id) {
  const res = await fetch(`${API_BASE}/products/${id}`);
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to load product');
  return await safeJson(res);
}

export async function createProduct(formData) {
  const res = await fetch(`${API_BASE}/products`, {
    method: 'POST',
    body: formData,
  });
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to create product');
  return await safeJson(res);
}

export async function updateProduct(id, formData) {
  formData.append('_method', 'PUT');
  const res = await fetch(`${API_BASE}/products/${id}`, {
    method: 'POST',
    body: formData,
  });
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to update product');
  return await safeJson(res);
}

export async function deleteProduct(id) {
  const res = await fetch(`${API_BASE}/products/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to delete product');
  return await safeJson(res);
}

